package org.example.zone360.pages.coachDetails.sessionAllDetails.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronDown
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronUp
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.zone360.components.CustomPagination
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.ResizableTextAreaField
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.models.GetClubPlayerData
import org.example.zone360.models.GetSentencesData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.pages.coachDetails.sessionAllDetails.CoachTokenSearch
import org.example.zone360.pages.coachDetails.sessionAllDetails.PlayerTokenSearch
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.getCurrentMilliseconds
import org.example.zone360.utils.getEmoji
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.Audio
import org.w3c.dom.HTMLTextAreaElement
import org.example.zone360.utils.updateTranscript

@Composable
fun HighlightSectionUI(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    sessionData: GetSessionsData,
    message: (String) -> Unit,
    disable: Boolean,
    isVideoDurationPlaying1: Boolean,
    isPlayingAll: Boolean,
    scope: CoroutineScope,
    highlightSegments: List<Pair<Float, Float>>,
    selectedKeyword: String?,
    getSentences: List<GetSentencesData>,
    currentlyPlayingIdFullSession: String?,
    currentlyPlayingIdHighlight: String?,
    currentlyPlayingIdHighlightCallBack: (String?) -> Unit,
    currentKeywordSegmentIndex: Int,
    currentKeywordSegmentIndexCallBack: (Int) -> Unit,
    showNames: Boolean,
    selectedName : String?,
    currentSentenceIndex: Int,
    currentSentenceIndexCallBack: (Int) -> Unit,
    currentSegmentTimeCallBack: (Pair<String, String>?) -> Unit,
    isSentenceLoading: Boolean,
    players: List<GetClubPlayerData>,
    coaches: List<GetClubCoachesData>,
    currentAudioRefHighlight: MutableState<Audio?>,
) {

    var isThisPlaying by remember { mutableStateOf(false) }
    var editingIndex by remember { mutableStateOf(-1) }
    var isTranscriptLoading by remember { mutableStateOf(false) }
    var editingNotesIndex by remember { mutableStateOf(-1) }
    var selectedPlayers by remember {
        mutableStateOf<Map<String, List<GetClubPlayerData>>>(
            emptyMap()
        )
    }
    var selectedCoaches by remember {
        mutableStateOf<Map<String, List<GetClubCoachesData>>>(
            emptyMap()
        )
    }
    var isLoadingNotes by remember { mutableStateOf(false) }
    var expandedIndex by remember { mutableStateOf(-1) }
    Column(
        modifier = Modifier.fillMaxWidth()
            .margin(topBottom = 10.px)
    )
    {
        if (isSentenceLoading) {
            Box(
                modifier = Modifier.fillMaxSize()
                    .height(400.px),
                contentAlignment = Alignment.Center
            ) {
                ProgressIndicator(size = 50.px)
            }
        } else {
            val filteredSentences = remember(
                selectedKeyword,
                selectedName,
                showNames,
                currentKeywordSegmentIndex,
                getSentences.size
            )
            {


                if (selectedKeyword != null) {
                    // ✅ Return ALL sentences with this keyword (for pagination)
                    getSentences
                        .filter { sentence ->
                            sentence.keywords?.any {
                                it.text.equals(selectedKeyword, ignoreCase = true)
                            } == true
                        }
                        .sortedBy { it.startTime }

                } else if (selectedName != null) {
                    // ✅ Return ALL sentences with this name (for pagination)
                    getSentences
                        .filter { sentence ->
                            sentence.keywords?.any { it.text.equals(selectedName, ignoreCase = true) } == true ||
                                    sentence.names?.any { it.text.equals(selectedName, ignoreCase = true) } == true
                        }
                        .sortedBy { it.startTime }

                } else if (showNames) {
                    getSentences
                        .filter { it.names?.isNotEmpty() == true }
                        .sortedBy { it.startTime }
                } else {
                    getSentences
                    getSentences
                        .filter { !it.keywords.isNullOrEmpty() }
                        .sortedByDescending { it.keywords?.size ?: 0 }
                }
            }
            if (filteredSentences.isEmpty()) {
                Box(
                    modifier = Modifier.fillMaxSize().height(400.px)
                        .padding(40.px),
                    contentAlignment = Alignment.Center
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = when {
                                selectedKeyword != null -> "No highlights found for keyword: $selectedKeyword"
                                selectedName != null -> "No highlights found for: $selectedName"
                                showNames -> "No highlights available for this session"
                                else -> "No highlights available for this session"
                            },
                            fontSize = 14.px,
                            color = sitePalette.textFieldTextColor.rgb,
                            textAlign = TextAlign.Center
                        )
                    }
                }
            } else {
                val visibleSentences = remember(
                    filteredSentences,
                    selectedKeyword,
                    selectedName,
                    currentSentenceIndex,
                    currentKeywordSegmentIndex
                )
                {
                    if (selectedKeyword != null || selectedName != null) {
                        // ✅ When keyword or name is selected, show only the current sentence (for single view)
                        val currentIndex = currentSentenceIndex
                        filteredSentences.getOrNull(currentIndex)?.let { listOf(it) }
                            ?: emptyList()
                    } else {
                        // No keyword or name selected - show all sentences (for list view) or paginated single view
                        filteredSentences.getOrNull(currentSentenceIndex)?.let { listOf(it) }
                            ?: emptyList()
                    }
                }

                visibleSentences.forEachIndexed { index, sentenceData ->
                    // Add this near other remember variables for each sentence
                    var currentNotes by remember(sentenceData.id) {
                        mutableStateOf(
                            sentenceData.notes
                        )
                    }
                    val sessionId = sentenceData.id
                    var audioProgress by remember {
                        mutableStateOf(
                            0f
                        )
                    }
                    scope.launch {
                        val taggedPlayers = sentenceData.tagPlayers

                        if (taggedPlayers?.isNotEmpty() == true) {
                            val filteredList =
                                mutableListOf<GetClubPlayerData>()
                            taggedPlayers.forEach { player ->
                                val filterPlayer =
                                    players.filter { it.uid == player }

                                if (filterPlayer.isNotEmpty()) {
                                    filteredList.add(filterPlayer.first())
                                }
                            }

                            selectedPlayers =
                                selectedPlayers.toMutableMap()
                                    .apply {
                                        put(
                                            sentenceData.id,
                                            filteredList
                                        )
                                    }
                        }
                    }
                    scope.launch {
                        val taggedCoaches = sentenceData.tagCoaches

                        if (taggedCoaches?.isNotEmpty() == true) {
                            val filteredList =
                                mutableListOf<GetClubCoachesData>()
                            taggedCoaches.forEach { coach ->
                                val filterCoach =
                                    coaches.filter { it.userId == coach }

                                if (filterCoach.isNotEmpty()) {
                                    filteredList.add(filterCoach.first())
                                }
                            }

                            selectedCoaches =
                                selectedCoaches.toMutableMap()
                                    .apply {
                                        put(
                                            sentenceData.id,
                                            filteredList
                                        )
                                    }
                        }
                    }
                    LaunchedEffect(currentlyPlayingIdHighlight) {
                        isThisPlaying =
                            currentlyPlayingIdHighlight == sessionId

                        if (currentlyPlayingIdHighlight == sessionId) {
                            val audioPlay =
                                currentAudioRefHighlight.value
                            audioPlay?.apply {
                                while (currentTime < sentenceData.endTime) {
                                    if (currentlyPlayingIdHighlight != sessionId) {
                                        pause()
                                        currentlyPlayingIdHighlightCallBack(null)
                                        currentAudioRefHighlight.value =
                                            null
                                        audioProgress = 0f
                                        isThisPlaying = false
                                        break
                                    }
                                    audioProgress =
                                        ((currentTime - sentenceData.startTime) / (sentenceData.endTime - sentenceData.startTime)).toFloat()
                                    delay(100)

                                    if (currentTime >= sentenceData.endTime) {
                                        pause()
                                        currentlyPlayingIdHighlightCallBack(null)
                                        currentAudioRefHighlight.value =
                                            null
                                        audioProgress = 0f
                                        isThisPlaying = false
                                        break
                                    }
                                }
                            }
                        }
                    }

                    LaunchedEffect(sessionId) {
                        if (currentlyPlayingIdHighlight != sessionId) {
                            currentAudioRefHighlight.value?.pause()
                            currentlyPlayingIdHighlightCallBack(null)
                            currentAudioRefHighlight.value = null
                            audioProgress = 0f
                            isThisPlaying = false
                        }
                    }

                    DisposableEffect(Unit) {
                        onDispose {
                            currentAudioRefHighlight.value?.pause()
                            currentlyPlayingIdHighlightCallBack(null)
                            currentAudioRefHighlight.value = null
                            audioProgress = 0f
                            isThisPlaying = false
                        }
                    }

                    if (sentenceData.keywords?.isNotEmpty() == true || sentenceData.names?.isNotEmpty() == true) {
                        key(sentenceData.id) {
                            Column(
                                modifier = Modifier.margin(bottom = 10.px)
                                    .fillMaxWidth()
                            ) {
                                Row(
                                    modifier = Modifier.fillMaxWidth()
                                        .padding(leftRight = 20.px)
                                        .flexWrap(FlexWrap.Wrap),
//                                                            horizontalArrangement = Arrangement.SpaceBetween,
//                                                            verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Column(modifier = Modifier) {
                                        // Keywords Row
                                        if (selectedKeyword == null && !showNames) {
                                            Row(
                                                modifier = Modifier.fillMaxWidth()
                                                    .margin(
                                                        topBottom = 10.px
                                                    )
                                                    .flexWrap(
                                                        FlexWrap.Wrap
                                                    )
                                                    .overflow(
                                                        overflowY = Overflow.Auto,
                                                        overflowX = Overflow.Hidden
                                                    )
                                            ) {
                                                sentenceData.keywords?.forEach { keyword ->
                                                    val keywordCategory =
                                                        keyword.keywordCategory
                                                    val keywordText =
                                                        keyword.text
                                                    Box {
                                                        Box(
                                                            modifier = Modifier.height(
                                                                32.px
                                                            )
                                                                .backgroundColor(
                                                                    when (keywordCategory) {
                                                                        "fitness" -> sitePalette.fitnessCategoryBackground.rgb
                                                                        "mental" -> sitePalette.mentalCategoryBackground.rgb
                                                                        "technical" -> sitePalette.technicalCategoryBackground.rgb
                                                                        "tactical" -> sitePalette.tacticalCategoryBackground.rgb
                                                                        "goalkeeper" -> sitePalette.goalKeeperCategoryBackground.rgb
                                                                        else -> sitePalette.primary.rgb.copyf(
                                                                            alpha = 0.1f
                                                                        )
                                                                    }
                                                                )
                                                                .borderRadius(
                                                                    7.px
                                                                )
                                                                .padding(
                                                                    leftRight = 8.px,
                                                                    topBottom = 4.px
                                                                )
                                                                .border(
                                                                    1.px,
                                                                    color =
                                                                        when (keywordCategory) {
                                                                            "fitness" -> sitePalette.fitnessCategoryBorder.rgb
                                                                            "mental" -> sitePalette.mentalCategoryBorder.rgb
                                                                            "technical" -> sitePalette.technicalCategoryBorder.rgb
                                                                            "tactical" -> sitePalette.tacticalCategoryBorder.rgb
                                                                            "goalkeeper" -> sitePalette.goalKeeperCategoryBorder.rgb
                                                                            else -> sitePalette.primary.rgb
                                                                        },
                                                                    style = LineStyle.Solid
                                                                )
                                                                .margin(
                                                                    7.px
                                                                ),
                                                            contentAlignment = Alignment.Center
                                                        ) {
                                                            FieldTitleTextNormalSimple(
                                                                keywordText
                                                            )
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        // ✅ ADD THIS NAMES ROW - Show names when on Names tab and no name selected
                                        if (selectedName == null && showNames) {
                                            Row(
                                                modifier = Modifier.fillMaxWidth()
                                                    .margin(
                                                        topBottom = 10.px
                                                    )
                                                    .flexWrap(
                                                        FlexWrap.Wrap
                                                    )
                                                    .overflow(
                                                        overflowY = Overflow.Auto,
                                                        overflowX = Overflow.Hidden
                                                    )
                                            ) {
                                                sentenceData.names?.forEach { name ->
                                                    val nameText = name.text
                                                    Box {
                                                        Box(
                                                            modifier = Modifier.height(32.px)
                                                                .backgroundColor(
                                                                    sitePalette.primary.rgb.copyf(
                                                                        alpha = 0.1f
                                                                    )
                                                                )
                                                                .borderRadius(7.px)
                                                                .padding(
                                                                    leftRight = 8.px,
                                                                    topBottom = 4.px
                                                                )
                                                                .border(
                                                                    1.px,
                                                                    color = sitePalette.primary.rgb,
                                                                    style = LineStyle.Solid
                                                                )
                                                                .margin(7.px),
                                                            contentAlignment = Alignment.Center
                                                        ) {
                                                            FieldTitleTextNormalSimple(
                                                                nameText.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
                                                            )
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        Row(
                                            modifier = Modifier.fillMaxWidth()
                                                .flexWrap(FlexWrap.Wrap)
                                        ) {
                                            Column {
                                                FieldTitleTextNormalSimple(
                                                    "Tag Coach",
                                                    fontFamily = Constants.IBM_FONT,
                                                    fontSize = 12.px,
                                                    fontWeight = 600,
                                                    marginBottom = 10.px,
                                                    marginTop = 10.px
                                                )
                                                CoachTokenSearch(
                                                    sitePalette = sitePalette,
                                                    breakpoint = breakpoint,
                                                    coaches = coaches,
                                                    currentCoachId = sessionData.userId,
                                                    selectedCoachesMap = selectedCoaches,
                                                    onCoachSelected = { sentenceId, coach ->
                                                        selectedCoaches =
                                                            selectedCoaches.toMutableMap()
                                                                .apply {
                                                                    put(
                                                                        sentenceId,
                                                                        (this[sentenceId]
                                                                            ?: emptyList()) + coach
                                                                    )
                                                                }
                                                    },
                                                    onCoachRemoved = { sentenceId, coach ->
                                                        selectedCoaches =
                                                            selectedCoaches.toMutableMap()
                                                                .apply {
                                                                    put(
                                                                        sentenceId,
                                                                        (this[sentenceId]
                                                                            ?: emptyList()) - coach
                                                                    )

                                                                }
                                                    },
                                                    sentenceId = sentenceData.id,
                                                    sessionId = sessionData.sessionId
                                                )

                                                // Tag Player
                                                FieldTitleTextNormalSimple(
                                                    "Tag Player",
                                                    fontFamily = Constants.IBM_FONT,
                                                    fontSize = 12.px,
                                                    fontWeight = 600,
                                                    marginBottom = 10.px,
                                                    marginTop = 10.px
                                                )
                                                PlayerTokenSearch(
                                                    sitePalette = sitePalette,
                                                    breakpoint = breakpoint,
                                                    players = players,
                                                    selectedPlayersMap = selectedPlayers,
                                                    onPlayerSelected = { sentenceId, player ->
                                                        selectedPlayers =
                                                            selectedPlayers.toMutableMap()
                                                                .apply {
                                                                    put(
                                                                        sentenceId,
                                                                        (this[sentenceId]
                                                                            ?: emptyList()) + player
                                                                    )
                                                                }
                                                    },
                                                    onPlayerRemoved = { sentenceId, player ->
                                                        selectedPlayers =
                                                            selectedPlayers.toMutableMap()
                                                                .apply {
                                                                    put(
                                                                        sentenceId,
                                                                        (this[sentenceId]
                                                                            ?: emptyList()) - player
                                                                    )
                                                                }
                                                    },
                                                    sentenceId = sentenceData.id
                                                )
                                            }


                                            CustomSpacer(100.px)
                                            Column(
                                                modifier = Modifier.width(
                                                    if (window.screen.width in 400..1330) 270.px else if (window.screen.width < 400) 100.percent else 400.px
                                                )
                                            )
                                            {
                                                Row(
                                                    modifier = Modifier,
                                                    verticalAlignment = Alignment.CenterVertically,
                                                ) {
                                                    FieldTitleTextNormalSimple(
                                                        "Notes",
                                                        fontFamily = Constants.IBM_FONT,
                                                        fontSize = 12.px,
                                                        fontWeight = 600,
                                                        marginBottom = 10.px,
                                                        marginTop = 10.px,
                                                        marginRight = 5.px
                                                    )
                                                    if (!disable) {
                                                        if (currentlyPlayingIdFullSession == null && currentlyPlayingIdHighlight == null && !isPlayingAll && !isVideoDurationPlaying1) {
                                                            Image(
                                                                src = Res.Images.gray_Pencil_Icon,
                                                                modifier = Modifier.size(
                                                                    10.px
                                                                )
                                                                    .cursor(
                                                                        Cursor.Pointer
                                                                    )
                                                                    .onClick {
                                                                        editingNotesIndex =
                                                                            index
                                                                    })
                                                        }
                                                    }
                                                }
                                                LaunchedEffect(
                                                    editingNotesIndex
                                                ) {
                                                    if (editingNotesIndex == index) {
                                                        (document.getElementById(
                                                            "${Res.Id.updateNotes}$index"
                                                        ) as? HTMLTextAreaElement)?.value =
                                                            currentNotes  // ✅ use currentNotes, not sentenceData.notes
                                                    }
                                                }
                                                if (editingNotesIndex == index) {
                                                    ResizableTextAreaField(
                                                        placeholder = "Write notes...",
                                                        width = 100.percent,
                                                        minHeight = 130.px,
                                                        maxHeight = 200.px,
                                                        resize = false,
                                                        backgroundColor = null,
                                                        id = "${Res.Id.updateNotes}$index",
                                                        isLoading = isLoadingNotes,
                                                        onSaveClick = {
                                                            scope.launch {
                                                                val notesValue =
                                                                    (document.getElementById(
                                                                        "${Res.Id.updateNotes}$index"
                                                                    ) as? HTMLTextAreaElement)?.value
                                                                        ?: ""

                                                                try {
                                                                    isLoadingNotes =
                                                                        true
                                                                    val response =
                                                                        updateTranscript(
                                                                            sentenceID = sentenceData.id,
                                                                            transcript = sentenceData.transcript,
                                                                            notes = notesValue,
                                                                            organization = AppGlobal.userData.organization,
                                                                            updateNotes = true

                                                                        )
                                                                    if (response.data == "Sentence updated successfully!") {
                                                                        sentenceData.notes =
                                                                            notesValue.trim()
                                                                        currentNotes =
                                                                            notesValue.trim()
                                                                        editingNotesIndex =
                                                                            getCurrentMilliseconds().toInt()
                                                                        message(
                                                                            "Notes updated successfully!"
                                                                        )
                                                                    } else {
                                                                        message(
                                                                            "Error updating notes: ${response.data}"
                                                                        )
                                                                    }
                                                                } catch (e: Exception) {
                                                                    console.error(
                                                                        "Error updating notes: ${e.message}"
                                                                    )

                                                                } finally {
                                                                    isLoadingNotes =
                                                                        false
                                                                }
                                                            }
                                                        },
                                                        onCancelClick = {
                                                            editingNotesIndex =
                                                                -1
                                                        }
                                                    )
                                                } else {
                                                    Box(
                                                        modifier = Modifier.fillMaxWidth()
                                                            .height(
                                                                130.px
                                                            )
                                                            .padding(
                                                                15.px
                                                            )
                                                            .border(
                                                                width = 1.px,
                                                                color = sitePalette.textFieldBorderColor.rgb,
                                                                style = LineStyle.Solid
                                                            )
                                                            .overflow(
                                                                overflowY = Overflow.Auto,
                                                                overflowX = Overflow.Hidden
                                                            )
                                                            .borderRadius(
                                                                5.px
                                                            )
                                                            .backgroundColor(
                                                                sitePalette.lightGrey.rgb
                                                            )
                                                    ) {
                                                        FieldTitleTextNormalSimple(
                                                            text = currentNotes,
                                                            width = 100.percent,
                                                            wordBreak = WordBreak.BreakAll,
                                                            whiteSpace = WhiteSpace.PreWrap
                                                        )

                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                Row(
                                    modifier = Modifier.fillMaxWidth()
                                        .padding(leftRight = 20.px)
                                        .margin(topBottom = 10.px),
                                    horizontalArrangement = Arrangement.SpaceBetween,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {

                                    Row {
                                        FieldTitleTextNormalSimple(
                                            text = getEmoji(
                                                sentenceData.emotions
                                            ) + sentenceData.emotions.replaceFirstChar {
                                                if (it.isLowerCase()) it.titlecase() else it.toString()
                                            },
                                            fontSize = 12.px,
                                            marginLeft = 3.px,
                                            fontWeight = 500,
                                            fontFamily = Constants.IBM_FONT
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = " . ",
                                            fontSize = 12.px,
                                            marginLeft = 3.px,
                                            fontWeight = 500,
                                            fontFamily = Constants.IBM_FONT
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = getEmoji(
                                                sentenceData.tone
                                            ) + sentenceData.tone.replaceFirstChar {
                                                if (it.isLowerCase()) it.titlecase() else it.toString()
                                            },
                                            marginLeft = 3.px,
                                            fontSize = 12.px,
                                            fontWeight = 500,
                                            fontFamily = Constants.IBM_FONT
                                        )
                                    }
                                    if (selectedKeyword == null && selectedName == null) {
                                        Row {
                                            if (expandedIndex == index) {
                                                FaChevronUp(
                                                    modifier = Modifier.color(
                                                        Colors.Gray
                                                    )
                                                        .cursor(Cursor.Pointer)
                                                        .onClick {
                                                            expandedIndex = -1
                                                        } // Collapse
                                                )
                                            } else {
                                                FaChevronDown(
                                                    modifier = Modifier.color(
                                                        Colors.Gray
                                                    )
                                                        .cursor(
                                                            Cursor.Pointer
                                                        )
                                                        .onClick {
                                                            expandedIndex =
                                                                index
                                                        }
                                                )
                                            }
                                        }
                                    }
                                }

                                scope.launch {
                                    delay(200)
                                    (document.getElementById("${Res.Id.updateTranscript}$index") as? HTMLTextAreaElement)?.value =
                                        sentenceData.transcript
                                }
                                if (expandedIndex == index || selectedKeyword != null || selectedName != null) {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .transition(
                                                Transition.of(
                                                    property = "height",
                                                    duration = 300.ms,
                                                    timingFunction = AnimationTimingFunction.EaseInOut
                                                )
                                            )
                                            .position(Position.Relative)
                                            .padding(
                                                right = if (editingIndex == index || currentlyPlayingIdFullSession == null && currentlyPlayingIdHighlight == null && !isPlayingAll) 10.px else 50.px,
                                                bottom = 10.px
                                            )
                                    ) {
                                        if (editingIndex == index) {
                                            ResizableTextAreaField(
                                                id = "${Res.Id.updateTranscript}$index",
                                                placeholder = "Edit Transcript...",
                                                isLoading = isTranscriptLoading,
                                                onSaveClick = {
                                                    scope.launch {
                                                        val transcriptValue =
                                                            (document.getElementById(
                                                                "${Res.Id.updateTranscript}$index"
                                                            ) as? HTMLTextAreaElement)?.value
                                                                ?: ""
                                                        try {
                                                            isTranscriptLoading =
                                                                true
                                                            val response =
                                                                updateTranscript(
                                                                    sentenceID = sentenceData.id,
                                                                    transcript = transcriptValue.trim(),
                                                                    notes = "",
                                                                    organization = AppGlobal.userData.organization,
                                                                    updateNotes = false
                                                                )
                                                            if (response.data == "Sentence updated successfully!") {
                                                                sentenceData.transcript =
                                                                    transcriptValue.trim()

                                                                editingIndex =
                                                                    getCurrentMilliseconds().toInt()
                                                                message(
                                                                    "Transcript updated successfully!"
                                                                )
                                                                showToast(
                                                                    "toastSuccess"
                                                                )
                                                            } else {
                                                                message(
                                                                    "Error updating transcript: ${response.data}"
                                                                )
                                                                showToast(
                                                                    "toastError"
                                                                )
                                                            }
                                                        } catch (e: Exception) {
                                                            message(
                                                                "Error updating transcript: ${e.message}"
                                                            )
                                                            showToast(
                                                                "toastError"
                                                            )
                                                        } finally {
                                                            isTranscriptLoading =
                                                                false
//                                                                                    editingIndex = -1
                                                        }
                                                    }
                                                },
                                                onCancelClick = {
                                                    editingIndex =
                                                        -1
                                                }
                                            )
                                        } else {
                                            Box(
                                                modifier = Modifier.minHeight(
                                                    80.px
                                                ).maxHeight(150.px)
                                                    .overflow(
                                                        overflowY = Overflow.Auto,
                                                        overflowX = Overflow.Hidden
                                                    )
                                            ) {
                                                FieldTitleTextNormalSimple(
                                                    sentenceData.transcript,
                                                    fontFamily = Constants.IBM_FONT,
                                                    fontSize = 14.px,
                                                    width = if (breakpoint < Breakpoint.MD) 80.percent else 95.percent,
                                                    marginLeft = 20.px,
                                                    marginRight = 20.px,
                                                    color = Colors.Gray
                                                )
                                            }
                                            if (!disable) {
                                                if (currentlyPlayingIdFullSession == null && currentlyPlayingIdHighlight == null && !isPlayingAll && !isVideoDurationPlaying1) {
                                                    Image(
                                                        src = Res.Images.gray_Pencil_Icon,
                                                        modifier = Modifier
                                                            .size(16.px)
                                                            .position(Position.Absolute)
                                                            .align(Alignment.TopEnd)
                                                            .margin(
                                                                right = 20.px,
                                                                bottom = 5.px
                                                            )
                                                            .cursor(Cursor.Pointer)
                                                            .onClick { editingIndex = index }
                                                    )
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (filteredSentences.isNotEmpty()) {
                    val currentPage = when {
                        selectedKeyword != null -> currentKeywordSegmentIndex
                        selectedName != null -> currentKeywordSegmentIndex  // ← CHANGE: Use keyword index for names too
                        else -> currentSentenceIndex
                    }
                    val totalPages = filteredSentences.size

                    // Debug logging

                    CustomPagination(
                        currentPage = currentPage,
                        totalPages = totalPages,
                        onPageChange = { page ->

                            if (selectedKeyword != null) {
                                currentKeywordSegmentIndexCallBack(page)
                                // Update the current segment time for the waveform
                                val segment = highlightSegments.getOrNull(page)
                                currentSegmentTimeCallBack(segment?.let { it.first.toString() to it.second.toString() })
                            } else if (selectedName != null) {
                                currentKeywordSegmentIndexCallBack(page)
                                // Update the current segment time for the waveform
                                val segment = highlightSegments.getOrNull(page)
                                currentSegmentTimeCallBack(segment?.let { it.first.toString() to it.second.toString() })
                            } else {
                                currentSentenceIndexCallBack(page)
                            }
                        },
                        sitePalette = sitePalette,
                        leftRightPadding = 25.px
                    )
                }

            }
        }
    }
}